import { render, staticRenderFns } from "./PatternProperties.vue?vue&type=template&id=a15a15a2&scoped=true"
import script from "./PatternProperties.vue?vue&type=script&setup=true&lang=ts"
export * from "./PatternProperties.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./PatternProperties.vue?vue&type=style&index=0&id=a15a15a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a15a15a2",
  null
  
)

export default component.exports